import React from "react";
import { CardContent, Typography, Stack, Box } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";

function DisposedAssets({ response }) {
  return (
    <>
      <StyledCard>
        <CardContent>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography
                mb={1.5}
                variant="h5"
                fontWeight={700}
                color={"text.primary"}
              >
                Disposed Assets
              </Typography>
              <Typography m={0} variant="h1" color={"error.dashboard"}>
                {response?.totalDisposedAssetCount}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default DisposedAssets;
